import isEmpty from 'lodash/isEmpty';
import { CampaignLocaleSwitcher } from 'modules/templateEditor/integrations/CampaignLocaleSwitcher';
import styled from 'styled-components';
import { useLocaleSettingsContext } from 'modules/campaigns/lib/contexts/LocaleSettingsContext';
import { pxToRem } from 'utils/convert';
import { useEditorContext, useTemplateContext } from '../../context';
import { CampaignEditorView } from '../../types';
import { EditViewActions } from './EditViewActions';
import { SummaryViewActions } from './SummaryViewActions';

const EDITOR_VIEW_ACTIONS_MAPPER = {
  [CampaignEditorView.Summary]: SummaryViewActions,
  [CampaignEditorView.Edit]: EditViewActions,
} as const;

const StyledContainer = styled.div`
  display: flex;
  gap: ${pxToRem(30)};
  flex-direction: column;
  align-items: flex-end;
`;

export const HeaderActions = ({
  isDefaultWhatsAppTemplate,
}: {
  isDefaultWhatsAppTemplate?: boolean;
}) => {
  const { locales } = useLocaleSettingsContext();
  const { templateState } = useTemplateContext();
  const { campaignEditorView } = useEditorContext();
  const ViewActions = EDITOR_VIEW_ACTIONS_MAPPER[campaignEditorView];

  return (
    <StyledContainer data-test="header-actions">
      {!isEmpty(locales) && !isDefaultWhatsAppTemplate && (
        <CampaignLocaleSwitcher hideErrorCount={templateState.isDefaultTemplate} />
      )}
      <ViewActions />
    </StyledContainer>
  );
};
